exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright {\n  width: 7.5rem;\n  height: 1rem;\n  overflow: hidden;\n  background-position: bottom;\n  background-repeat: no-repeat;\n  position: relative;\n  color: #CEDFFB;\n}\n.copyright .ti {\n  text-align: center;\n  line-height: 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/activity/202408tr/Copyright/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/activity/202408tr/Copyright/index.less
// module chunks = 0